import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getFromLocalStorage,
  saveInLocalStorage,
} from "../../config/localStorage";
import AddressInputForm from "../forms/textField/AddressInputForm";
import { useFormik } from "formik";
import { addressValidationSchema } from "../../utils/validationSchemas";

interface CustomerInformationProps {
  businessInfo: Record<string, string | number | boolean | any>;
  isLoading: boolean;
  shippingError: string;
  setIsCustomerInformationAdded: (value: boolean) => void;
  setComponentToDisplay: (selection: string) => void;
}

const CustomerInformation: React.FC<CustomerInformationProps> = ({
  businessInfo,
  isLoading,
  shippingError,
  setIsCustomerInformationAdded,
  setComponentToDisplay,
}) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
    },
    validationSchema: addressValidationSchema,
    onSubmit: (values) => {
      // Save data and navigate to the next step
      saveInLocalStorage("customerInfo", values);
      setIsCustomerInformationAdded(true);
    },
  });

  const textFieldStyles = {
    "& .MuiInputLabel-root": {
      color: theme.palette.primary.dark,
    },
    "& .MuiInputBase-input": {
      color: theme.palette.primary.dark,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.dark,
    },
    "& .MuiInputBase-root.Mui-focused .MuiInputBase-input": {
      color: theme.palette.primary.dark,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.dark,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.dark,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.dark,
      },
    },
  };

  useEffect(() => {
    const tempCustomerInfo = getFromLocalStorage("customerInfo");
    if (tempCustomerInfo?.firstName) {
      formik.setValues(tempCustomerInfo);
    }
  }, []);

  return (
    <Container>
      <Box
        sx={{
          mt: 4,
          p: 3,
          padding: 0,
          marginTop: 0,
          color: theme.palette.primary.main,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <IconButton
            onClick={() => setComponentToDisplay("CART")}
            sx={{ color: theme.palette.primary.dark }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{
              fontSize: 18,
              textAlign: "center",
              flexGrow: 1,
            }}
          >
            Customer Information
          </Typography>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <AddressInputForm
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            touched={formik.touched}
            textFieldStyles={textFieldStyles}
            businessInfo={businessInfo}
          />
          <Grid container justifyContent={"flex-end"}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                mt: 2,
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.light,
              }}
              disabled={isLoading}
            >
              {isLoading ? "Please Wait..." : "Proceed"}
            </Button>
          </Grid>
        </form>
        {/* {shippingError && (
          <Typography
            variant="body2"
            color="error"
            sx={{ marginTop: 2, textAlign: "center" }}
          >
            {shippingError}
          </Typography>
        )} */}
      </Box>
    </Container>
  );
};

export default CustomerInformation;
